module.exports = __webpack_public_path__ + "assets/img/hero_2.22aa6ccb.png";